export const STATUS_401 = 'UNAUTHENTICATED';
export const REFRESH_LIMIT = 1;
